import DeleteConfirmation from './delete-modal'
import InputTypeBasic  from './tm-rent-basic'
import InputTypeDetailed from './tm-rent-detailed'

export default {
  DeleteConfirmation,
  InputTypeBasic,
  InputTypeDetailed
}